import type { MembershipResponse, UserRole } from "../types";
import InviteListItem from "./invite-list-item";

export interface InviteListProps {
	memberships: MembershipResponse[];
	className?: string;
	onDelete?: (id: string, workspaceId: string) => void;
	onResendInvite?: (id: string, workspaceId: string) => void;
	blockedByPlan?: boolean;
	brandUrl?: string;
	userRole?: UserRole | null;
}

export default function InviteList({ memberships, className = "", onDelete, onResendInvite, blockedByPlan, brandUrl, userRole }: InviteListProps) {
	return (
		<div className={`divide-y divide-gray-100 ${className}`}>
			{memberships.map((member, index) => (
				<InviteListItem
					key={`${member.id}-${index}`}
					membership={member}
					onDelete={onDelete ? (id) => onDelete(id, member.workspace_id) : undefined}
					onResendInvite={onResendInvite ? (id) => onResendInvite(id, member.workspace_id) : undefined}
					blockedByPlan={blockedByPlan}
					brandUrl={brandUrl}
					userRole={userRole}
				/>
			))}
		</div>
	);
}
